import React, { useEffect, useState } from "react";
import { Loader2, Mail, Info, Send, Users } from "lucide-react";
import { api } from "../../api";

const AdminEmail = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => {
    api.get("/admin/campaigns").then((r) => setCampaigns(r.data));
    api.get("/admin/customers").then((r) => setCustomers(r.data));
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!subject || !message) return;
    setBusy(true);
    try { await api.post("/admin/campaigns", { subject, message }); setSubject(""); setMessage(""); load(); }
    finally { setBusy(false); }
  };

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-display text-3xl font-bold uppercase text-[#1B2a21]">Mass Email</h1>
      <p className="mb-5 text-[#6b7d72]">Compose a campaign to everyone who buys from you ({customers.length} customers)</p>

      <div className="mb-5 flex items-start gap-3 rounded-2xl border border-[#f0d9a0] bg-[#fdf6e6] p-4">
        <Info size={20} className="mt-0.5 shrink-0 text-[#b4790a]" />
        <p className="text-sm text-[#7a5a14]">
          <strong>Heads up:</strong> For anti-spam reasons, bulk marketing blasts cannot be sent through our shared transactional email system. You can compose and save campaigns here; to actually send marketing emails to your whole list, connect a dedicated provider (e.g. Mailchimp) — we can wire that up as a next step. Order & subscription emails send automatically.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-2xl border border-[#e6f0ea] bg-white p-5">
          <div className="mb-3 flex items-center gap-2"><Mail size={18} className="text-[#2D6A4F]" /><h2 className="font-display text-lg font-bold uppercase text-[#1B2a21]">Compose</h2></div>
          <label className="mb-1 block font-display text-xs font-semibold uppercase tracking-wider text-[#2D6A4F]">Subject</label>
          <input value={subject} onChange={(e) => setSubject(e.target.value)} className="mb-3 w-full rounded-xl border border-[#dceadf] px-4 py-2.5 text-sm outline-none focus:border-[#52B788]" placeholder="e.g. New arrivals this month" />
          <label className="mb-1 block font-display text-xs font-semibold uppercase tracking-wider text-[#2D6A4F]">Message</label>
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={7} className="mb-3 w-full rounded-xl border border-[#dceadf] px-4 py-2.5 text-sm outline-none focus:border-[#52B788]" placeholder="Write your campaign..." />
          <div className="flex items-center justify-between">
            <span className="flex items-center gap-1 text-sm text-[#6b7d72]"><Users size={15} /> {customers.length} recipients</span>
            <button onClick={save} disabled={busy || !subject || !message} className="flex items-center gap-2 rounded-full bg-[#2D6A4F] px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:bg-[#1B4332] disabled:opacity-50">{busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Save Campaign</button>
          </div>
        </div>

        <div className="rounded-2xl border border-[#e6f0ea] bg-white p-5">
          <h2 className="mb-3 font-display text-lg font-bold uppercase text-[#1B2a21]">Saved Campaigns</h2>
          {campaigns.length === 0 ? <p className="text-sm text-[#8aa093]">No campaigns yet.</p> : (
            <div className="space-y-3">
              {campaigns.map((c) => (
                <div key={c.id} className="rounded-xl border border-[#eef5f0] p-4">
                  <div className="flex items-center justify-between"><p className="font-semibold text-[#1B2a21]">{c.subject}</p><span className="rounded-full bg-[#f0f7f2] px-2.5 py-1 text-xs font-semibold text-[#2D6A4F]">{c.recipients} recipients</span></div>
                  <p className="mt-1 line-clamp-2 text-sm text-[#6b7d72]">{c.message}</p>
                  <p className="mt-2 text-xs text-[#8aa093]">{(c.created_at || "").slice(0, 10)} · {c.status}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminEmail;
